import React from 'react';
import './BackButton.scss';

function BackButton() {
  return (
    <div className="back-button-container">
      <a href="https://ygy.finance">Go back</a>
    </div>
  );
}

export default BackButton;

